import * as api from '../api.service';
import DomainToApiObjectMapper from '../../mappers/domainToApiObject.mapper';
import { PriorAuthorizationRequest } from '../../interfaces/PriorAuthorizationRequest';
import { PriorAuthorizationDomain } from '../../interfaces/PriorAuthorizationDomain';

const submitPriorAuhtorization = async (data: PriorAuthorizationDomain) => {
  const mappedData = DomainToApiObjectMapper.ToApiObject(data);
  return api.post<PriorAuthorizationRequest>(`${process.env.REACT_APP_API_URL}/prior-authorization/submit`, mappedData);
};

const savePriorAuthorization = async (data: PriorAuthorizationDomain) => {
  const mappedData = DomainToApiObjectMapper.ToApiObject(data);
  return api.put<PriorAuthorizationRequest>(`${process.env.REACT_APP_API_URL}/prior-authorization/save`, mappedData);
};

const PriorAuthorizationService = {
  submitPriorAuhtorization,
  savePriorAuthorization,
};

export default PriorAuthorizationService;
